function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.89934 4.10512C4.89379 4.0995 4.88639 4.09725 4.88084 4.09163L1.31301 0.16452C1.11228 -0.0548401 0.786673 -0.0548401 0.585942 0.16452C0.584092 0.16677 0.583167 0.16902 0.582242 0.171269C0.533637 0.220075 0.494382 0.281199 0.46722 0.35037C0.440058 0.419542 0.425645 0.495092 0.424988 0.571742L0.424988 8.42708C0.426025 8.50513 0.441143 8.58196 0.469275 8.65213C0.497406 8.7223 0.537865 8.7841 0.587793 8.83317L0.585942 8.83542C0.686942 8.94158 0.815981 9 0.949478 9C1.08297 9 1.21201 8.94158 1.31301 8.83542L4.89934 4.89932C4.94657 4.85032 4.9845 4.78944 5.01051 4.72088C5.03652 4.65233 5.04999 4.57772 5.04999 4.50222C5.04999 4.42672 5.03652 4.35212 5.01051 4.28356C4.9845 4.215 4.94657 4.15413 4.89934 4.10512Z",
  fill: "#462F8D"
});

var SvgArrowClose = function SvgArrowClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowClose.cbd53f3f.svg";
export { ForwardRef as ReactComponent };